import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCapsuleFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3.99057 13.6019C1.33648 10.9478 1.33648 6.64466 3.99057 3.99057C6.64466 1.33648 10.9478 1.33648 13.6019 3.99057L20.0094 10.3981C22.6635 13.0522 22.6635 17.3553 20.0094 20.0094C17.3553 22.6635 13.0522 22.6635 10.3981 20.0094L3.99057 13.6019Z",
			fill: "#D5C7DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.80814 17.4187L6.55469 16.1653L7.05021 16.0698C7.0499 16.0699 7.05028 16.0698 7.0512 16.0696L7.06506 16.0666C7.07944 16.0635 7.10403 16.0578 7.13825 16.0492C7.2067 16.0319 7.31359 16.0028 7.45417 15.9579C7.73537 15.8681 8.15111 15.7153 8.66363 15.4683C9.6878 14.9748 11.1012 14.1037 12.6026 12.6024C14.1039 11.1011 14.9751 9.68749 15.4688 8.66318C15.7158 8.15059 15.8686 7.73477 15.9585 7.45352C16.0034 7.31291 16.0325 7.206 16.0498 7.13753C16.0585 7.10331 16.0641 7.0787 16.0673 7.06432L16.0703 7.05048C16.0705 7.04957 16.0706 7.04915 16.0705 7.04946L16.166 6.55396L17.4194 7.80733C17.4094 7.83999 17.3988 7.8742 17.3874 7.90992C17.2779 8.25263 17.0997 8.73402 16.82 9.31443C16.2601 10.4761 15.2946 12.0317 13.6632 13.663C12.0319 15.2944 10.4764 16.2598 9.31482 16.8196C8.73446 17.0993 8.25311 17.2774 7.91044 17.3868C7.87483 17.3982 7.84072 17.4088 7.80814 17.4187Z",
			fill: "#865E9C"
		})
	]
});
const ForwardRef = forwardRef(SvgCapsuleFill);
export { ForwardRef as ReactComponent };
